<div class="container-fluid" style="padding: 0;height: 100vh;">
    <img src="https://firebasestorage.googleapis.com/v0/b/dapper-page.appspot.com/o/projects%2Fprojects_title.png?alt=media&token=230bfa17-6f25-477a-98c7-0b2b183ece3f"
        alt="" class="logo-dapper">
</div>